Vue.component('vue-dynamic-content', {
  template: '#vue-dynamic-content',
  data: function () {
    return {
      content: "",
      title: ""
    }
  },
  created: function () {
    this.getContent();
  },
  methods: {
    getContent: function () {
      const self = this;
      $.post("/back/dynamic/DynamicContent.php", { name: router.currentRoute.name }, function (result, textStatus) {
        if (result.content !== null) {
          self.content = result.content;
        }
        if (result.title !== null) {
          self.title = result.title;
        }
        if (router.currentRoute.name == "Bilety autobusowe Polonus") {
          let script = document.createElement('script');
          script.onload = function () {
            let evt = document.createEvent('Event');
            evt.initEvent('load', false, false);
            window.dispatchEvent(evt);
          }
          script.id = 'searchBox-widget';
          script.src = '//dworzeconline.pl/static/plugins/searchbox/searchBox.js?type=3&carrier=&partner=540bd1d4-bb8a-11ea-814d-005056890445';
          script.type = 'text/javascript';
          document.head.appendChild(script);
        }
      }, "json");
    }
  }
});
